import { createContext } from "react";

export interface INotificationBadgeContext {
    closeMenu: () => void;
}

export const NotificationBadgeContext = createContext<INotificationBadgeContext>({
    closeMenu: () => {}
});